/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/postAuditLogEntryCountsOverrides';

export type PostAuditLogEntryCountsQueryParams = NonNullable<
  operations['postAuditLogEntryCounts']['parameters']['query']
>;

export type PostAuditLogEntryCountsRequestBody = OperationRequestBodyContent<operations['postAuditLogEntryCounts']>;

export interface Input {
  apiVersion?: string;
  query: PostAuditLogEntryCountsQueryParams;
  body: PostAuditLogEntryCountsRequestBody;
}

export async function postAuditLogEntryCounts(
  { apiVersion, body, query }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/auditlog/counts', {
    params: { query },
    body,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
